import { render } from "./HospitalKpi.vue?vue&type=template&id=e722b594&scoped=true"
import script from "./HospitalKpi.vue?vue&type=script&lang=js"
export * from "./HospitalKpi.vue?vue&type=script&lang=js"

import "./HospitalKpi.vue?vue&type=style&index=0&id=e722b594&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e722b594"]])

export default __exports__